import $ from 'jquery'

import PoziAPIData from 'api/data'
import * as PoziUtils from 'api/utils'

export const POZI_SHARE_REDIRECTOR_URL = 'https://api.pozi.com/redirector'
export const POZI_SHARE_LINK_URL = 'https://go.pozi.com'

const unableToFindGoLink = (view = 'UNKNOWN') => {
  console.error('Found redirector, but unable to find view.', view)
  $('body').html($('#go-link-not-found').removeClass('hidden'))

  PoziUtils.gtag({
    category: 'program',
    status: 'warning',
    identifier: view,
    action: 'go redirect not found',
    additionalInfo: window.location.href
  })
}

/**
 * Handle redirect from go.pozi.com shared short URLs
 */
export const redirectToSharedLink = () => {
  let view = ''
  const hash = window.location.hash
  const hashLastIndexOfSlash = hash.lastIndexOf('/')
  if (hashLastIndexOfSlash > -1) {
    view = hash.substring(hash.lastIndexOf('/'), hash.length).replace('/', '').toLowerCase()
  }

  if (view.length === 0) {
    unableToFindGoLink()
    return
  }

  // Use the redirector API to build the URL from the shared short URL.
  const redirectorCreateURL = `${POZI_SHARE_REDIRECTOR_URL}?view=${view}`

  PoziAPIData().ajax({
    url: redirectorCreateURL,
    method: 'GET',
    error: function (jqXHR, textStatus, errorThrown) {
      console.error('Unable to get redirector.', jqXHR, textStatus, errorThrown)
      unableToFindGoLink()
    },
    success: (response, textStatus, jqXHR) => {
      console.debug('PoziDrawerTabToolsShare - Redirector write response.', response)
      if (!response?.success || !response?.url) {
        unableToFindGoLink()
        return
      }
      console.debug('PoziDrawerTabToolsShare - Found redirector get URL and redirect...', response)
      try {
        PoziUtils.gtag({
          category: 'program',
          status: 'success',
          identifier: view,
          action: 'go redirect success',
          additionalInfo: response.url
        })

        document.location.replace(response.url)
      } catch (err) {
        console.error('Unable to redirect.', err)

        const errorMsg = err.message || 'Unknown error'

        PoziUtils.gtag({
          category: 'program',
          status: 'warning',
          identifier: view,
          action: 'go redirect fail',
          additionalInfo: `${errorMsg}. URL: ${response.url}`
        })
      }
    }
  })
}
